const common = {
  root: {
    height: '100%',
    padding: '8px',
    display: 'flex',
    flexFlow: 'column',
    gap: '24px',
    position: 'relative'
  },

  loginBox: {
    width: '100%',
    display: 'flex'
  },

  leftSideContent: {
    width: '544px'
  },

  rightSideContent: {
    width: '432px'
  },

  bottomContent: {}
}

export const tablet = {
  ...common,
  loginBox: {
    ...common.loginBox,
    height: '640px',
    padding: `0 72px`,
    paddingTop: '20px',
    flexFlow: 'row',
    justifyContent: 'space-between'
  },

  bottomContent: {
    height: '152px'
  }
}

export const web = {
  ...common,

  root: {
    ...common.root,
    gap: 0
  },

  loginBox: {
    ...common.loginBox,
    flexFlow: 'column',
    alignItems: 'center'
  },

  leftSideContent: {
    width: '640px',
    textAlign: 'center'
  },

  rightSideContent: {
    width: '400px'
  }
}
